import { render, staticRenderFns } from "./topbar.vue?vue&type=template&id=585d7a5c&scoped=true"
import script from "./topbar.vue?vue&type=script&lang=js"
export * from "./topbar.vue?vue&type=script&lang=js"
import style0 from "./topbar.vue?vue&type=style&index=0&id=585d7a5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585d7a5c",
  null
  
)

export default component.exports